var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Search"},[(_vm.showSearchResults)?_c('ApplicationsLanding'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }